export default [
  {
    header: 'Report',
    resource: 'report',
    action: ['read', 'update'],
  },
  {
    title: 'Win / Lose',
    icon: 'AwardIcon',
    route: 'win-lose',
    resource: 'report',
    action: ['read', 'update'],
  },
  {
    title: 'Transaction',
    icon: 'TrelloIcon',
    route: 'transaction',
    resource: 'report',
    action: ['read', 'update'],
  },
  {
    title: 'Lotto Report',
    icon: 'FileTextIcon',
    route: 'lotto-report',
    resource: 'report',
    action: ['read', 'update'],
  },
  {
    title: 'poyReport.title',
    icon: 'LayersIcon',
    route: 'poy-report',
    resource: 'report',
    action: ['read', 'update'],
  },
]
